/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize ConstructionAccessAssessment View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './ConstructionAccessAssessmentView';

export const mapStateToPropsConstructionAccessAssessment = mapStateToProps;
export const mapDispatchToPropsConstructionAccessAssessment =
  mapDispatchToProps;

export default connect(
  mapStateToPropsConstructionAccessAssessment,
  mapDispatchToPropsConstructionAccessAssessment
)(View);
